export default class HeypsterTag{
    constructor(tag){

        const tagElement = document.createElement('div');
        tagElement.classList.add('heypster-tag');
        tagElement.textContent = tag.tag;

        return tagElement;
    }
}